module.exports = __webpack_public_path__ + "static/claudiu-1c7ea8b77a388f9e604a6e82714de171.jpg";